import React, { useEffect, useState } from 'react'
import { gql, useLazyQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { __error, __yellow } from 'Common/scripts/consoleHelper';
import { defaultPageSize } from 'configs';
import { Icon, DevBlock, Loader } from 'Common/components';
import { Alert, Space, Tag, Timeline, Image, Card } from 'antd';
import { mongoToDate, parseNewLine } from 'Common/scripts/Functions';
import { defaultDateFormat, defaultDateTimeFormat } from 'configs';
import { ContentArea } from 'Layout_v1';
import { ListHeader } from 'Common/components/Typography';
import { CiCircleOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { uriRoot } from 'configs';

const HILIGHTS = loader('src/Graphql/dorsHilights/dorsHilightsQuery.graphql');

const img_fallback = `data:image/png;base64,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`



function TimelineView({ dataArray }) {
    if (!dataArray || dataArray.length < 1) return null;
    return (<>
        <ListHeader title="DOR hilights" />
        <div style={{ height: "5px" }} />

        <ContentArea style={{ margin: "0", height: "400px", overflow: "auto" }}>
            <Timeline>
                {dataArray.map((note, i) => {
                    let timelineHead = [];
                    if (note?.client?._id) timelineHead.push(<Tag>Client: <b>{note?.client?.name}</b></Tag>)
                    if (note?.site?._id) timelineHead.push(<Tag>Site: <b>{note?.site?.name}</b></Tag>)
                    if (note?.guard?._id) timelineHead.push(<Tag>Guard: <b>{note?.guard?.name}</b></Tag>)
                    if (note?.is_followup) timelineHead.push(<Tag><Icon icon="clock" color="orange" /> Reminder: <b>{note.reminder ? mongoToDate(note.reminder).format(defaultDateTimeFormat) : null}</b></Tag>)

                    return <Timeline.Item key={i} dot={note.flag == 'important' ? <Icon color="red" icon="flag" /> : undefined}>
                        <div style={{ fontSize: "12px", color: "#999", fontWeight: 600 }}>
                            by: <span style={{ color: "#000" }}><Link to={`${uriRoot}/dors/${note.dor_id}`}>{note.user.name}</Link></span> {mongoToDate(note.created_at).format(defaultDateTimeFormat)}
                        </div>
                        {timelineHead && timelineHead.length > 0 && <>{timelineHead}</>}
                        <div style={{ fontWeight:"bold" }}>{note.subject}</div>
                        <div>{parseNewLine(note.note)}</div>

                        {(note.attachments && note.attachments.length > 0) && <>
                            <Space wrap direction='horizontal'>
                                {note.attachments && note.attachments.map((o, i) => {
                                    let temp = o.srcUrl.split(".");
                                    let ext = temp[temp.length - 1];

                                    {/* let isImg = o.srcUrl.toLowerCase().indexOf('.jpeg') > -1 || o.srcUrl.toLowerCase().indexOf('.jpg') > -1 || o.srcUrl.toLowerCase().indexOf('.gif') || o.srcUrl.toLowerCase().indexOf('.png'); */ }
                                    let isImg = (['jpeg', 'jpg', 'gif', 'png'].indexOf(ext) > -1);
                                    let isPdf = (['pdf'].indexOf(ext) > -1);
                                    let isWord = (['doc', 'docx'].indexOf(ext) > -1);

                                    let icon = <Icon icon="file" />;
                                    if (isPdf) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file-pdf" color="#000" /></span>
                                    else if (isWord) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file-word" /></span>
                                    else if (!isImg) icon = <span style={{ fontSize: "18px", marginRight: "5px" }}><Icon icon="file" /></span>

                                    let path = `${process.env.REACT_APP_DATA_URL}/${o.srcUrl}`;

                                    return <div key={i} style={{ border: '1px solid #EEE', margin: '5px 0' }}>
                                        {isImg && <Image src={path} height={70} fallback={img_fallback} />}
                                        {!isImg && <a href={path} target="_blank" rel="noreferrer">{<>{icon} {o.title}</>}</a>}
                                    </div>
                                })}
                            </Space>

                        </>}

                        {/* <DevBlock obj={note} /> */}
                    </Timeline.Item>
                })}
            </Timeline>
        </ContentArea>
    </>)
}




export function DorsHighlights() {
    const [data, setData] = useState(null)

    const [dorsHilightsQuery, hilights_results] = useLazyQuery(
        HILIGHTS, {
            variables: {
                first: 25,
                after: 0,
                filter: JSON.stringify({}),
                others: JSON.stringify({}),
            }
        }
    )

    useEffect(() => {
        if (hilights_results.called) return;
        fetchData();
    }, [])

    const fetchData = async() => {
        let resutls = await dorsHilightsQuery().then(r => (r?.data?.dorsHilightsQuery))
        .catch(err=>{
            console.log(__error("Error: "), err);
            return { error:{message:"Unable to fetch hilights"}}
        })
        setData(resutls)
    }

    if (hilights_results.loading) return <Loader loading={true}>Loading hilights...</Loader>
    if (!data || data.totalCount < 1) return <Alert type='warning' message="No Hilights available" showIcon />
    if (data.error) return <Alert type='error' message={data?.error?.message} showIcon />

    return (<>
        <TimelineView dataArray={data.edges} />
        {/* <DevBlock obj={data.edges} /> */}
    </>)
}
